/**
 * Material system constants
 */

/**
 * Root URL for material binaries on R2 (without version path).
 * Set via VITE_MATERIAL_ROOT_URL environment variable.
 */
export const MATERIAL_ROOT_URL = import.meta.env.VITE_MATERIAL_ROOT_URL || 'https://materials.wrldy.xyz/binaries';

/**
 * Base URL for material binaries on R2.
 * Set via VITE_MATERIAL_URL environment variable.
 * Falls back to a placeholder if not set.
 * @deprecated Use getLatestMaterialUrl() for dynamic version resolution
 */
export const MATERIAL_BASE_URL = import.meta.env.VITE_MATERIAL_URL || '/materials';

/**
 * Dev-only: absolute path to a local `materials/output` directory (no trailing slash), set via
 * VITE_MATERIAL_LOCAL_DIR. When set, textures are read straight off disk through Vite's /@fs
 * instead of R2, and the IndexedDB cache is bypassed entirely so a re-bundle shows up on reload.
 *
 * Gated on DEV because /@fs only exists on the dev server — this branch is compiled out of a
 * production build, so a stray env var cannot ship a dead URL.
 */
const materialLocalDir = import.meta.env.VITE_MATERIAL_LOCAL_DIR || '';
export const MATERIAL_LOCAL = import.meta.env.DEV && materialLocalDir !== '';

/**
 * Base URL for the local bundle. The bundler's layout (`output/<resolution>/<map>.bin`) already
 * matches what the loader asks for, so this stands in for the versioned R2 URL unchanged.
 */
export const MATERIAL_LOCAL_URL = `/@fs${materialLocalDir}`;

/**
 * Texture repeat scale for tri-planar mapping.
 * Lower values = more zoomed in, higher = more repetition.
 */
export const TERRAIN_MATERIAL_REPEAT_SCALE = 2.0;

/**
 * Blend offset for tri-planar normal rotation (radians).
 */
export const TERRAIN_MATERIAL_BLEND_OFFSET_RAD = 0.2;

/**
 * First LOD whose texture is enlarged. Levels below keep the authored scale — they are close enough
 * that the texture is not being averaged away.
 */
export const TERRAIN_LOD_TEX_FIRST_LOD = 3;

/**
 * How much larger the world-space texture gets per LOD level from there (1 = off). Coarse terrain
 * repeats the texture so many times per pixel that the mip chain averages it to a flat colour.
 */
export const TERRAIN_LOD_TEX_PER_LOD = 2.0;
